import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useRef } from 'react';
import { Helmet } from 'react-helmet';
import { ProfessionalTopView } from '@/components/pages/top/ProfessionalTopView';
import Layout from '@/container/Layout';
import { useTypeSelector } from '@/hooks/state/useTypeSelector';
import { useHeaderState } from '@/hooks/ui/Header/useHeaderState';
import { useSetHeaderViewModeJudgeRef } from '@/hooks/ui/Header/useSetHeaderViewModeJudgeRef';
import { PROFFIT_DEFAULT_OGP } from '@/utils/constants/assets/s3';
import { META_DESCRIPTION } from '@/utils/constants/seo/meta';
import { isGuest } from '@/utils/resources/auth/authResource';
import { getAbsolutePath, forConsultantTopPath } from '@/utils/router/links';
/**
 * コンサルタント向けTOPページ
 * @returns
 */
export const ProfessionalTopPage = (props) => {
    const { caseList, newsList, professionalCount, rfpCount, themeList } = props;
    const auth = useTypeSelector((state) => state.auth);
    const isGuestUser = isGuest(auth);
    const headerViewModeJudgeRef = useRef();
    const setJudgeRef = useSetHeaderViewModeJudgeRef({
        judgeRef: headerViewModeJudgeRef,
    });
    const headerState = useHeaderState({ targetRef: headerViewModeJudgeRef });
    const title = 'コンサルタントの方へ | PROFFIT';
    const description = META_DESCRIPTION.forConsultant();
    return (_jsxs(Layout, Object.assign({ guestHeaderViewMode: headerState.isTargetScrolled ? 'normal' : 'expand', headerType: 'top' }, { children: [_jsxs(Helmet, { children: [_jsx("title", { children: title }), _jsx("meta", { content: description, name: 'description' }), _jsx("meta", { content: title, property: 'og:title' }), _jsx("meta", { content: description, property: 'og:description' }), _jsx("meta", { content: 'website', property: 'og:type' }), _jsx("meta", { content: 'PROFFIT', property: 'og:site_name' }), _jsx("meta", { content: getAbsolutePath(forConsultantTopPath()), property: 'og:url' }), _jsx("meta", { content: PROFFIT_DEFAULT_OGP, property: 'og:image' })] }), _jsx(ProfessionalTopView, { caseList: caseList, mainVisualSize: isGuestUser ? 'large' : 'normal', newsList: newsList, professionalCount: professionalCount, rfpCount: rfpCount, setHeaderJudgeRef: setJudgeRef, themeList: themeList })] })));
};
